module.exports = __webpack_public_path__ + "img/trade-service-parts-display-navy.2398f516.png";